/**
 * Guide attribution — Phase 131b.
 *
 * When a visitor reads a guide (/blog/<slug>) we remember the FIRST one in
 * localStorage for 30 days. At coach signup the slug rides along on
 * POST /auth/signup so Admin → Blog can show "this guide created N coaches".
 * First-touch only: reading five guides still credits the one that brought
 * them in. Nothing personal is stored — just a slug and a timestamp.
 */
const KEY = 'sp_guide_touch';
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

export function rememberGuideTouch(slug) {
    try {
        if (!slug || typeof window === 'undefined') return;
        const raw = window.localStorage.getItem(KEY);
        if (raw) {
            const cur = JSON.parse(raw);
            if (cur && cur.slug && Date.now() - Date.parse(cur.ts) < TTL_MS) return; // keep first touch
        }
        window.localStorage.setItem(KEY, JSON.stringify({ slug: String(slug).slice(0, 120), ts: new Date().toISOString() }));
    } catch { /* storage blocked — attribution is best-effort */ }
}

export function readGuideTouch() {
    try {
        if (typeof window === 'undefined') return null;
        const raw = window.localStorage.getItem(KEY);
        if (!raw) return null;
        const cur = JSON.parse(raw);
        if (!cur || !cur.slug || Date.now() - Date.parse(cur.ts) > TTL_MS) return null;
        return { guide_slug: cur.slug, guide_seen_at: cur.ts };
    } catch { return null; }
}

export function clearGuideTouch() {
    try { window.localStorage.removeItem(KEY); } catch { /* ignore */ }
}
